import Loading from '@components/Loading';
import { AppScreen } from '@stackflow/plugin-basic-ui';
import { ActivityComponentType, useFlow } from '@stackflow/react';
import { useEffect } from 'react';
import { toast } from 'sonner';

declare module '@stackflow/config' {
    interface Register {
        EasyCardIdentifyFailActivity: {
            errorCode?: string;
            message?: string;
        };
    }
}

const EasyCardIdentifyFailActivity: ActivityComponentType<'EasyCardIdentifyFailActivity'> = ({ params }) => {
    const { errorCode, message } = params;
    const { push, replace } = useFlow();
    useEffect(() => {
        replace('MainActivity', {}, { animate: false });
        push('EasyCardActivity', {});
        console.error({ errorCode, message });
        setTimeout(() => {
            toast.error(message || '본인인증에 실패했어요.');
        }, 400);
    }, []);
    return (
        <AppScreen>
            <Loading/>
        </AppScreen>
    );
};

export default EasyCardIdentifyFailActivity;
